var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-5"},[_c('b-card',{staticClass:"home-wrapper"},[_c('b-spinner',{staticClass:"spinner-outer",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"variant":"primary","label":"Loading..."}}),_vm._v(" =="+_vm._s(_vm.loadingAgreements)+" ++ ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }